import { z } from 'zod';
import { ANALYTICS_EVENT_TYPES, DEMO_FEEDBACK_QUESTIONS } from '../domain/analytics.js';

/**
 * Метка из ссылки (`utm_source` и соседи).
 *
 * Только буквы, цифры и `_ - . + ~`, до 64 знаков, строчными. Что-то другое
 * отбрасывается молча: регистрация из-за кривой метки отказывать не должна, а
 * произвольный текст в журнале событий не нужен — туда не должно попасть,
 * например, имя, вписанное в ссылку.
 */
const utmValue = z
  .string()
  .trim()
  .toLowerCase()
  .max(64)
  .regex(/^[\p{L}\p{N}_.+~-]+$/u)
  .optional()
  .catch(undefined);

/** Откуда пришёл человек — если ссылка это сообщила. */
export const registrationSourceSchema = z
  .object({ utmSource: utmValue, utmMedium: utmValue, utmCampaign: utmValue })
  .optional()
  .catch(undefined);
export type RegistrationSource = NonNullable<z.infer<typeof registrationSourceSchema>>;

/** Один ответ на один из двух вопросов после итога демо. */
export const demoFeedbackSchema = z.discriminatedUnion('question', [
  z.object({
    question: z.literal('clear'),
    answer: z.enum(Object.keys(DEMO_FEEDBACK_QUESTIONS.clear.answers) as ['yes', 'partly', 'no']),
  }),
  z.object({
    question: z.literal('full'),
    answer: z.enum(Object.keys(DEMO_FEEDBACK_QUESTIONS.full.answers) as ['yes', 'maybe', 'no']),
  }),
]);
export type DemoFeedbackInput = z.infer<typeof demoFeedbackSchema>;

/** Период и фильтр отчёта. Границы — моменты времени ISO; без них — всё время. */
export const analyticsQuerySchema = z.object({
  from: z.string().datetime().optional(),
  to: z.string().datetime().optional(),
  type: z.enum(ANALYTICS_EVENT_TYPES).optional(),
});
export type AnalyticsQuery = z.infer<typeof analyticsQuerySchema>;
